import { createFileRoute } from "@tanstack/react-router";

const TARGET_URL = "https://meetmychat.com/mtz-dyqi-qwv";

export const Route = createFileRoute("/aovivo")({
  head: () => ({
    meta: [
      { title: "Ao Vivo — Cura pela Alimentação" },
      { name: "robots", content: "noindex, nofollow" },
      { httpEquiv: "refresh", content: `0; url=${TARGET_URL}` },
    ],
    links: [{ rel: "canonical", href: TARGET_URL }],
  }),
  component: AoVivoRedirect,
});

function AoVivoRedirect() {
  if (typeof window !== "undefined") {
    window.location.replace(TARGET_URL);
  }
  return (
    <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
      Redirecionando para{" "}
      <a href={TARGET_URL} style={{ color: "#2563eb" }}>
        {TARGET_URL}
      </a>
      ...
    </div>
  );
}
